module.exports = __webpack_public_path__ + "static/media/animal-welfare-accountability.8bd75919.jpg";